module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    },
    on: {
      "click": function($event) {
        _vm.triggerInfiniteBool = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bullhorn"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.headerNotiAnnounceTotal > 0),
      expression: "headerNotiAnnounceTotal > 0"
    }],
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.numberFormat(_vm.headerNotiAnnounceTotal)))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "noti-header"
  }, [(_vm.headerNotiAnnounceTotal > 0) ? [_vm._v("\n        " + _vm._s(_vm.labels[_vm.nowLang]['new_message1']) + " " + _vm._s(_vm.numberFormat(_vm.headerNotiAnnounceTotal)) + " " + _vm._s(_vm.labels[_vm.nowLang]['new_message2']) + "\n      ")] : [_vm._v("\n        " + _vm._s(_vm.labels[_vm.nowLang]['no_message']) + "\n      ")]], 2), _vm._v(" "), _c('li', [_c('ul', {
    staticClass: "announce-list"
  }, [_vm._l((_vm.headerNotiAnnounceRows), function(headerAnn) {
    return _c('li', [_c('div', {
      staticClass: "pull-left announce-box"
    }, [_vm._m(0, true), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: 'hres3fx'
        }
      }
    }, [_c('div', {
      staticClass: "announce-topic-box clearfix"
    }, [_c('div', {
      staticClass: "announce-topic"
    }, [_vm._v("\n                " + _vm._s(headerAnn.subject) + " \n                ")]), _vm._v(" "), _c('small', [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(" " + _vm._s(_vm.setDateOutput(headerAnn.dteeffec)))]), _vm._v(" "), _c('div', {
      staticClass: "announce-detail"
    }, [_vm._v(_vm._s(headerAnn.remark))])])])], 1)])
  }), _vm._v(" "), (_vm.triggerInfiniteBool) ? _c('hrms-infinite-loading', {
    ref: "headerNotiAnnounceLoading",
    on: {
      "infinite": _vm.onInfinite
    }
  }) : _vm._e()], 2)]), _vm._v(" "), _c('li', {
    staticClass: "footer"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'hres3fx'
      }
    }
  }, [_vm._v(_vm._s(_vm.labels[_vm.nowLang]['view_all']))])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "announce-icon-box"
  }, [_c('i', {
    staticClass: "fa fa-bullhorn"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-134c7f95!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dash/headers/HeaderAnnounce.vue
// module id = 3570
// module chunks = 1